import { render, staticRenderFns } from "./ProjectEditLayoutSettingsTab.vue?vue&type=template&id=96981eba"
import script from "./ProjectEditLayoutSettingsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditLayoutSettingsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports